<template>
	<div>
		<b-navbar toggleable="lg" variant="faded" type="light" fixed="top" class="pb-0">
			<b-navbar-brand to="/">
				<img src="@/assets/images/BI.svg" alt="Logo Bravo Izquierdo" class="logo">
			</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav class="ml-auto d-none d-lg-block">
					<b-table-simple borderless condensed class="text-right my-0">
						<b-tr>
							<b-td style="color: #B12424" class="py-3">
								<strong>@bravo</strong>izquierdocl
								<b-link href="https://www.facebook.com/bravoizquierdocl" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'facebook-f']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.instagram.com/bibravoizquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'instagram']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.linkedin.com/company/bravo-izquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424;" />
										<font-awesome-icon :icon="['fab', 'linkedin']" transform="shrink-6" class="text-white" style="font-size:20px" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.youtube.com/channel/UChKwaxagm1960GydfTLNecQ" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424;" />
										<font-awesome-icon :icon="['fab', 'youtube']" transform="shrink-6" class="text-white" style="font-size:20px" />
									</font-awesome-layers>
								</b-link>
							</b-td>
						</b-tr>
						<b-tr>
							<b-td class="py-0">
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" @click="openLink(project.folleto.link)" v-if="project.folleto">folleto</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" @click="openLink(project.folleto_pdf.link)" v-if="project.folleto_pdf">folleto</b-button>
								<b-button @click="goTo('quote', {project_id: project.url})" squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br" type="button" v-if="project.project_id">Plantas</b-button>
								<b-button @click="goTo('project', {project_id: project.url, scrollTo: '#project-images'})" squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.details">Imágenes</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.travel_src && project.url != 'cu'" v-b-modal.modal-travel>PRESENTACIÓN PROYECTO</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.travel_src && project.url == 'cu'" v-b-modal.modal-travel>Piloto Virtual Depto 2D</b-button>
								
								<!--<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.depto && project.url == 'connection'" v-b-modal.modal-depto>Tour virtual</b-button>-->
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.tour_virtual" v-b-modal.modal-tour-virtual>Tour Virtual</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.tour_virtual2 && project.url == 'cu' && project.btn_piloto_v1" v-b-modal.modal-tour-virtual2>Piloto Virtual Depto 1D</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.pilot_src && project.url != 'cu'" v-b-modal.modal-pilot>Piloto Virtual</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.pilot_src && project.url == 'cu' && project.btn_vitual_studio" v-b-modal.modal-pilot>Piloto Virtual Studio</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.terrain_src" v-b-modal.modal-360>Entorno 360º</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" v-if="project.advance_src && project.avance_obra" v-b-modal.modal-advance>Avance de obra</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" @click="goTo('project', {project_id: project.url, scrollTo: '#project-map'})" v-if="project.location">Ubicación</b-button>
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-navbar-nav>
				<b-navbar-nav class="d-lg-none text-left p-4">
					<b-nav-item link-classes="btn btn-bravoizq text-white rounded-0 border-bottom-br" @click="goTo('home', {scrollTo: '#sell-project'})">En Venta</b-nav-item>
					<b-nav-item link-classes="btn btn-bravoizq text-white rounded-0 border-bottom-br" :to="{name: 'coming' }">Próximamente</b-nav-item>
					<b-nav-item link-classes="btn btn-bravoizq text-white rounded-0" :href="$store.state.clientURL">Mí Cuenta</b-nav-item>
					<b-table-simple borderless condensed class="text-right my-0">
						<b-tr>
							<b-td style="color: #B12424" class="py-3">
								<strong>@bravo</strong>izquierdocl
								<b-link href="https://www.facebook.com/bravoizquierdocl" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'facebook-f']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.instagram.com/bibravoizquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'instagram']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.linkedin.com/company/bravo-izquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424;" />
										<font-awesome-icon :icon="['fab', 'linkedin']" transform="shrink-6" class="text-white" style="font-size:20px" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.youtube.com/channel/UChKwaxagm1960GydfTLNecQ" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424;" />
										<font-awesome-icon :icon="['fab', 'youtube']" transform="shrink-6" class="text-white" style="font-size:20px" />
									</font-awesome-layers>
								</b-link>
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
		<b-modal id="modal-360" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.terrain_src">
			<b-embed type="video" controls v-if="project.terrain_is_video">
				<source :src="project.terrain_src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.terrain_src"></b-embed>
		</b-modal>
		<b-modal id="modal-travel" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.travel_src">
			<b-embed type="video" controls v-if="project.travel_is_video">
				<source :src="project.travel_src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.travel_src"></b-embed>
		</b-modal>
		<b-modal id="modal-depto1" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.depto1">
			<b-embed :src="project.depto1"></b-embed>
		</b-modal>
		<b-modal id="modal-depto" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.depto">
			<b-embed type="video" controls v-if="project.depto.is_video">
				<source :src="project.depto.src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.depto.src"></b-embed>
		</b-modal>
		<b-modal id="modal-tour-virtual" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.tour_virtual">
			<b-embed type="video" controls v-if="project.tour_virtual.is_video">
				<source :src="project.tour_virtual.src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.tour_virtual.src"></b-embed>
		</b-modal>
		<b-modal id="modal-tour-virtual2" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.tour_virtual2">
			<b-embed type="video" controls v-if="project.tour_virtual2.is_video">
				<source :src="project.tour_virtual2.src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.tour_virtual2.src"></b-embed>
		</b-modal>
		<b-modal id="modal-pilot" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.pilot_src">
			<b-embed type="video" controls v-if="project.pilot_is_video">
				<source :src="project.pilot_src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.pilot_src"></b-embed>
		</b-modal>
		<b-modal id="modal-advance" size="xl" centered hide-header body-bg-variant="transparent" content-class="border-0 bg-transparent" hide-footer v-if="project.advance_src">
			<b-embed type="video" controls v-if="project.advance_is_video">
				<source :src="project.advance_src" type="video/mp4">
			</b-embed>
			<b-embed v-else :src="project.advance_src"></b-embed>
		</b-modal>
		<b-modal id="modal-lightbox" size="lg" centered hide-header hide-footer body-bg-variant="transparent" content-class="border-0 bg-transparent"  v-if="project.lightbox">			
			<!--<b-embed :src="project.lightbox.src"></b-embed>-->			
			<b-img :src="project.lightbox.src" fluid center v-if="project.lightbox.link" @click="openLink(project.lightbox.link)"></b-img>
			<b-img :src="project.lightbox.src" fluid center v-else @click="$bvModal.hide('modal-lightbox')"></b-img>			
		</b-modal>
		<b-modal id="modal-bci" size="lg" centered hide-header hide-footer body-bg-variant="transparent" content-class="border-0 bg-transparent"  v-if="project.btn_bci">						
			<bci-widget api-key="RtqtGGyaK7GiOcSBnO0hne6aVYNAHj9n" proyecto="iqapartment" :vendedor="vendedor" style="text-align: left"></bci-widget>
		</b-modal>
	</div>
</template>
<script>
	export default {
		name: 'NavBar',
		props: {
			project: {
				id: {default: null},
				images: {default: null},
				apartments: {default: null},
				vendedor:"",
			},
		},
		components: {},
		methods: {
			scrollToElem(elemName) {
				window.scroll({
					top: document.querySelector(elemName).offsetTop,
					behavior: 'smooth'
				});
			},
			goTo(url, params){
				if(this.$route.name == url && params.scrollTo){
					this.scrollToElem(params.scrollTo);
				}else{
					if(this.$route.name != url){
						this.$router.push({ name: url, params: params }).catch(err => { console.log('ERROR:',err) });
					}
				}
			},
			openLink(url){				
				window.open(url);
			}
		}
	}
</script>
<style>
	.btn-br{
		background: #b12525 !important;
		color: white !important;
		border-radius: 1px;
		box-shadow: none !important;
		padding: 10px 20px !important;
		text-transform: uppercase;
	}
	.navbar {
		background: rgba(183, 183, 183, 0.66);
		z-index: 1000;
	}
	.logo{
		width: 90px;
		margin-left: 45px;
	}
	#modal-pilot, #modal-360, #modal-advance, #modal-pilot___BV_modal_outer_, #modal-360___BV_modal_outer_, #modal-advance___BV_modal_outer_{
		z-index: 99999 !important;
	}
</style>
